import cn from 'classnames/bind';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Spinner, SpinnerSize } from '@/shared/components/Spinner';

import styles from './ProgramLoader.module.css';

const cx = cn.bind(styles);

export const ProgramLoaderComponent: FC = () => (
    <div className={cx('root')}>
        <span className={cx('loader-text')}>
            <FormattedMessage
                id="features.channel-program.8524de963f07201e5c086830d370797f"
                defaultMessage="Loading..."
                description="Текст загрузки телепрограммы"
            />
        </span>
        <Spinner size={SpinnerSize.BIG} />
    </div>
);
